<template>
    <div>
        <div class="container mb-4">
            <h1>Reset your password</h1>
        </div>
        <ResetPasswordForm
            @success="status = 'success'"
            @fail="status = 'fail'"
            @expired="status = 'expired'"
            v-if="status==''"
        />
        <div class="container" v-if="status == 'success'">
            <div class="col-md-8">
                <div class="alert alert-success">
                    <p class="mt-2">
                        <strong>Email sent!</strong>
                    </p>
                    <p>We've sent you an email confirming your password is reset.</p>
                    <p>
                        You can now
                        <router-link to="/">login</router-link>.
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'expired'">
            <div class="col-md-8">
                <div class="alert alert-danger">
                    <p class="mt-2">
                        <strong>Oops! That didn't work.</strong>
                    </p>
                    <p>
                        Your reset code expired. Please try
                        <router-link to="/forgot-password">resetting your password</router-link>&nbsp;again.
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'fail'">
            <div class="col-md-8">
                <div class="alert alert-danger">
                    <p class="mt-2">
                        <strong>Oops! That didn't work.</strong>
                    </p>
                    <p>We seem to be having issues with this service. Please reach out to The Film Office for help.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResetPasswordForm from "@/components/ResetPasswordForm";

export default {
    name: "reset-password",
    components: {
        ResetPasswordForm
    },
    data() {
        return {
            status: ""
        };
    }
};
</script>